"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestApiServiceProvider = exports.RestApiServiceContext = exports.RestApiServiceParamsContext = exports.useRestApiService = exports.restApiService = exports.getErrorSourceFromRestError = exports.RestErrorSource = void 0;
var axios_1 = require("axios");
var query_string_1 = require("query-string");
var React = require("react");
var RestErrorSource;
(function (RestErrorSource) {
    RestErrorSource[RestErrorSource["Server"] = 0] = "Server";
    RestErrorSource[RestErrorSource["Cancelled"] = 1] = "Cancelled";
})(RestErrorSource = exports.RestErrorSource || (exports.RestErrorSource = {}));
var cancelled = { errorSource: RestErrorSource.Cancelled };
function getErrorSourceFromRestError(response) {
    var _a;
    return (_a = response === null || response === void 0 ? void 0 : response.errorSource) !== null && _a !== void 0 ? _a : RestErrorSource.Server;
}
exports.getErrorSourceFromRestError = getErrorSourceFromRestError;
var emptyErrorData = {
    error: {
        code: '',
        detail: '',
        summary: '',
    }
};
function restApiService(_a) {
    var baseUrl = _a.baseUrl, siteLuid = _a.siteLuid, xsrfToken = _a.xsrfToken, handle401 = _a.handle401, wrapRequestWith = _a.wrapRequestWith;
    function makeAxiosRequest(config) {
        var axiosConfig = __assign(__assign({}, config), { baseURL: baseUrl });
        return axios_1.default(axiosConfig)
            .then(function (_a) {
            var data = _a.data;
            return data;
        }, function (response) {
            var _a, _b, _c, _d, _e, _f;
            if (axios_1.default.isCancel(response)) {
                return Promise.reject(cancelled);
            }
            var innerResponse = {
                errorSource: RestErrorSource.Server,
                data: (_b = (_a = response.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : emptyErrorData,
                status: (_d = (_c = response.response) === null || _c === void 0 ? void 0 : _c.status) !== null && _d !== void 0 ? _d : 400,
                statusText: (_f = (_e = response.response) === null || _e === void 0 ? void 0 : _e.statusText) !== null && _f !== void 0 ? _f : 'No status text was provided',
            };
            if (innerResponse.status === 401) {
                var reason = parseInt(innerResponse.data.error.code, 10);
                handle401 && handle401(reason);
            }
            return Promise.reject(innerResponse);
        });
    }
    function makeRestApiRequest(params) {
        var _a;
        var restApiVersion = params.restApiVersion, endpoint = params.endpoint, requestBody = params.requestBody, queryParams = params.queryParams, serverWideRequest = params.serverWideRequest, noPrefix = params.noPrefix, cancelTokenSource = params.cancelTokenSource, cancelToken = params.cancelToken, config = __rest(params, ["restApiVersion", "endpoint", "requestBody", "queryParams", "serverWideRequest", "noPrefix", "cancelTokenSource", "cancelToken"]);
        var url = noPrefix ? endpoint : serverWideRequest ? "api/" + restApiVersion + "/" + endpoint : "api/" + restApiVersion + "/sites/" + siteLuid + "/" + endpoint;
        if (queryParams) {
            url += "?" + query_string_1.stringify(queryParams);
        }
        var axiosConfig = __assign(__assign({}, config), { data: requestBody, url: url, method: "" + config.httpMethod, cancelToken: (_a = cancelTokenSource === null || cancelTokenSource === void 0 ? void 0 : cancelTokenSource.token) !== null && _a !== void 0 ? _a : cancelToken });
        var makeRequest = function () { return makeAxiosRequest(axiosConfig); };
        return wrapRequestWith ? wrapRequestWith(makeRequest) : makeRequest();
    }
    function makeJsonRestApiRequest(config, request, queryParams) {
        var isRequestDefined = (request !== null && request !== undefined);
        var requestString = isRequestDefined ? JSON.stringify(request) : null;
        return makeRestApiRequest(__assign(__assign({}, config), { queryParams: queryParams, requestBody: requestString, headers: xsrfToken ? {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-XSRF-Token': xsrfToken,
                'WithCredentials': true
            } : {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            } }));
    }
    return { makeRestApiRequest: makeRestApiRequest, makeJsonRestApiRequest: makeJsonRestApiRequest };
}
exports.restApiService = restApiService;
function useRestApiService() {
    var restApiServiceParams = React.useContext(exports.RestApiServiceParamsContext);
    var _a = React.useContext(exports.RestApiServiceContext), service = _a.service, rest = __rest(_a, ["service"]);
    var _b = React.useState(function () { return service !== null && service !== void 0 ? service : restApiService(rest.params.siteLuid ? rest.params : restApiServiceParams); })[0], makeJsonRestApiRequest = _b.makeJsonRestApiRequest, makeRestApiRequest = _b.makeRestApiRequest;
    return { makeJsonRestApiRequest: makeJsonRestApiRequest, makeRestApiRequest: makeRestApiRequest };
}
exports.useRestApiService = useRestApiService;
var defaultRestApiServiceParams = {
    siteLuid: "",
    baseUrl: window.location.origin,
};
/** @deprecated use RestApiServiceProvider */
exports.RestApiServiceParamsContext = React.createContext(defaultRestApiServiceParams);
exports.RestApiServiceContext = React.createContext({ params: defaultRestApiServiceParams });
function RestApiServiceProvider(props) {
    return (React.createElement(exports.RestApiServiceContext.Provider, { value: { params: props.params, service: props.service } }, props.children));
}
exports.RestApiServiceProvider = RestApiServiceProvider;
//# sourceMappingURL=RestApiService.js.map